// import { useEffect, useState } from "react"

import { Page, Text, View, Document } from '@react-pdf/renderer';

import { styles } from './styles/styles';
import { Header } from './common/header';
import { FooterStyle1 } from './common/footer';
import { BodyTopStyle7 } from './common/bodyTop';
import { BodyMainHeaderStyle12, BodyMainHeaderStyle13, BodyMainHeaderStyle14 } from './common/bodyMainHeader';
import { BodyMainFooterStyle6 } from './common/bodyMainFooter';
import { BodyMainRowStyle12, BodyMainRowStyle13, BodyMainRowStyle14 } from './common/bodyMainRow';

// config
const _documentLabel = 'PICK ORDER';

const RenderBodyMain = ({ routeType, pageNumber, totalPages, data, summary }) => {
  return (
    <View
      style={{
        fontWeight: 800,
      }}
    >
      <BodyMainHeaderStyle12 />
      <View>
        {data.map((i, index) => {
          return <BodyMainRowStyle12 key={index} row={i} index={index} />;
        })}
      </View>
      {pageNumber === totalPages && <BodyMainFooterStyle6 data={data} summary={summary} />}
    </View>
  );
};

/*
 * item by document view
 */
const RenderBodyMain2 = ({ routeType, pageNumber, totalPages, data, summary, document }) => {
  const docItemData = data.map((item) => item.doc_items).flat();

  return (
    <View
      style={{
        fontWeight: 800,
      }}
    >
      <BodyMainHeaderStyle13 />
      <View>
        {docItemData.map((i, index) => {
          return <BodyMainRowStyle13 key={index} document={data[index]} row={i} index={index} />;
        })}
      </View>
      {pageNumber === totalPages && <BodyMainFooterStyle6 data={docItemData} summary={summary} />}
    </View>
  );
};

/*
 * item by location view
 */
const RenderBodyMain3 = ({ routeType, pageNumber, pickLocations, totalPages, data, summary, document }) => {
  const docItemData = data.map((item) => item.doc_items).flat();
  console.log('pickLocation', pickLocations);

  let pickLocationItems = [];

  Object.keys(pickLocations).forEach((item) => {
    pickLocationItems.push(pickLocations[item]);
  });

  return (
    <View
      style={{
        fontWeight: 800,
      }}
    >
      <BodyMainHeaderStyle14 />
      <View>
        {pickLocationItems.map((i, index) => {
          return <BodyMainRowStyle14 key={index} row={i} index={index} />;
        })}
      </View>
      {pageNumber === totalPages && <BodyMainFooterStyle6 data={pickLocationItems} summary={summary} />}
    </View>
  );
};

const RenderHeader = (props) => {
  const { document, header } = props;

  return (
    <Header
      {...props}
      document={{
        header,
        documentName: _documentLabel,
        documentNumber: document?.doc_number,
      }}
    />
  );
};

const RenderPage = ({
  routeType,
  pageVariants,
  pageNumber,
  pickLocations,
  totalPages,
  qrCodeData,
  data,
  document,
  header,
  summary,
}) => {
  if (pageVariants.renderDataType === 'Items By Document') {
    return (
      <Page size="A4" style={styles.page} wrap>
        <View render={(props) => <RenderHeader {...props} document={document} header={header} />} fixed />
        <BodyTopStyle7 pageNumber={pageNumber} qrCodeData={qrCodeData} totalPages={totalPages} document={document} />
        <RenderBodyMain2
          pageNumber={pageNumber}
          totalPages={totalPages}
          document={document}
          data={data}
          summary={summary}
        />
        <FooterStyle1 document={document} />
      </Page>
    );
  }

  if (pageVariants.renderDataType === 'Items By Location') {
    return (
      <Page size="A4" style={styles.page} wrap>
        <View render={(props) => <RenderHeader {...props} document={document} header={header} />} fixed />
        <BodyTopStyle7 pageNumber={pageNumber} qrCodeData={qrCodeData} totalPages={totalPages} document={document} />
        <RenderBodyMain3
          pageNumber={pageNumber}
          totalPages={totalPages}
          document={document}
          data={data}
          pickLocations={pickLocations}
          summary={summary}
        />
        <FooterStyle1 document={document} />
      </Page>
    );
  }

  return (
    <Page size="A4" style={styles.page} wrap>
      <View render={(props) => <RenderHeader {...props} document={document} header={header} />} fixed />
      <BodyTopStyle7 pageNumber={pageNumber} qrCodeData={qrCodeData} totalPages={totalPages} document={document} />
      <RenderBodyMain
        pageNumber={pageNumber}
        totalPages={totalPages}
        document={document}
        data={data}
        summary={summary}
      />
      <FooterStyle1 document={document} />
    </Page>
  );
};

export function Output({ routeType, document, data, account, pageVariants }) {
  const {
    document: _document,
    docs: _docs,
    document_header: _documentHeader,
    qrCodeData,
    pick_locations: _pickLocations,
  } = data;

  const rowPerPage = 12;

  // calculate total pages
  const totalPages = Math.floor(_docs.length / rowPerPage);

  let array = [];

  for (let i = 0; i <= totalPages; i += 1) {
    array.push(i);
  }

  // calculate total summary
  const totalQty = _docs.reduce((total, val) => total + parseFloat(val?.qty), 0);

  const summary = {
    totalQty,
  };

  return (
    <Document title={document?.title}>
      {array.map((i, index) => {
        const startFrom = index === 0 ? 0 : index * rowPerPage;
        const startTo = index === 0 ? rowPerPage : startFrom + rowPerPage;

        // slide the needed array subset data
        const data = _docs.slice(startFrom, startTo);

        return (
          <RenderPage
            routeType={routeType}
            pageNumber={i + 1}
            totalPages={array.length}
            qrCodeData={qrCodeData}
            account={account}
            document={_document}
            pickLocations={_pickLocations}
            header={_documentHeader}
            pageVariants={pageVariants}
            data={data}
            key={index}
            summary={summary}
          />
        );
      })}
    </Document>
  );
}
